export const CREATE_SPIN_GAME_REQUEST = "CREATE_SPIN_GAME_REQUEST";
export const CREATE_SPIN_GAME_SUCCESS = "CREATE_SPIN_GAME_SUCCESS";
export const CREATE_SPIN_GAME_FAIL = "CREATE_SPIN_GAME_FAIL";
export const RESET_DELETE_SPIN_GAME = "RESET_DELETE_SPIN_GAME";
export const FETCH_SPIN_GAMES_REQUEST = "FETCH_SPIN_GAMES_REQUEST";
export const FETCH_SPIN_GAMES_SUCCESS = "FETCH_SPIN_GAMES_SUCCESS";
export const FETCH_SPIN_GAMES_FAIL = "FETCH_SPIN_GAMES_FAIL";
export const UPDATE_SPIN_GAME_REQUEST = "UPDATE_SPIN_GAME_REQUEST";
export const UPDATE_SPIN_GAME_SUCCESS = "UPDATE_SPIN_GAME_SUCCESS";
export const UPDATE_SPIN_GAME_FAIL = "UPDATE_SPIN_GAME_FAIL";
export const DELETE_SPIN_GAME_REQUEST = "DELETE_SPIN_GAME_REQUEST";
export const DELETE_SPIN_GAME_SUCCESS = "DELETE_SPIN_GAME_SUCCESS";
export const DELETE_SPIN_GAME_FAIL = "DELETE_SPIN_GAME_FAIL";
export const FETCH_SPIN_GAME_REQUEST = "FETCH_SPIN_GAME_REQUEST";
export const FETCH_SPIN_GAME_SUCCESS = "FETCH_SPIN_GAME_SUCCESS";
export const FETCH_SPIN_GAME_FAIL = "FETCH_SPIN_GAME_FAIL";
